/* eslint-disable no-nested-ternary */
import React from 'react';
import styled from 'styled-components';
import DonutChart from 'Components/common/charts/DonutChart';
import { useSelector } from 'react-redux';
import {
  selectLoading, selectSimilarArticleDetailLoading,
} from 'Selector/ArticleSector';
import { Article, ArticleExtraInfoConcept } from 'Types/ArticleTypes';
import classNames from 'classnames';
import DrawerHeading from './DrawerHeading';
import EntityTile from './EntityTile';
import ArticleDrawerSkeleton from '../skeleton/ArticleDrawerSkeleton';

const StyleWrapper = styled.div``;

export const formatConcepts = (concepts: ArticleExtraInfoConcept[]) => concepts?.map(
  ({ name, relevance }: ArticleExtraInfoConcept) => ({
    name,
    y: Math.floor(Number(relevance) * 100),
  }),
);
type Props = {
  article: Article | null,
  noMargin?: boolean,
  isSimilarArticle: boolean
} & typeof defaultProps;

const defaultProps = {
  noMargin: false,
};
const ArticleInfoConcepts = function ArticleInfoConcepts(props: Props) {
  const { noMargin, article, isSimilarArticle } = props;
  const articleLoading = useSelector(selectLoading);
  const similarArticleloading = useSelector(selectSimilarArticleDetailLoading);
  const loading = isSimilarArticle ? similarArticleloading : articleLoading;

  return (
    <StyleWrapper>
      {article?.articleExtraInfo && article?.articleExtraInfo.concepts
        && article?.articleExtraInfo.concepts.length > 0 && !loading
        ? (
          <div className={classNames('concepts-margin')}>
            {noMargin ? null : (
              <DrawerHeading heading="Concepts mentioned" />
            )}
            <div>
              <DonutChart data={formatConcepts(article?.articleExtraInfo.concepts ?? [])} />
            </div>
          </div>
        )
        : null}
      {loading ? <ArticleDrawerSkeleton />
        : article?.articleExtraInfo && article?.articleExtraInfo.entities
          && article?.articleExtraInfo?.entities.length > 0
          ? (
            <div className="entities-margin">
              <DrawerHeading heading="Entities mentioned" />
              <div className="d-flex entities_Block wrap-slider forOverFlow hidden-scroll">
                {article?.articleExtraInfo.entities
                  && article?.articleExtraInfo?.entities.length > 0
                  && article?.articleExtraInfo?.entities.slice(0, 3).map((item) => (
                    <EntityTile
                      engagements={item.engagement}
                      company={item.name}
                      margin="0px 10px 0px 0px"
                    />
                  ))}
              </div>
            </div>
          )
          : null}
    </StyleWrapper>
  );
};
ArticleInfoConcepts.defaultProps = defaultProps;
export default ArticleInfoConcepts;
